<template>
  <div class="content-container work-container" :class="viewMode">
    <article class="work detail-content">
      <div class="fixed-container">
        <div class="inner">
          <div class="icon-cancel" title="Close" @click="hideFull()"></div>
        </div>
      </div>
      <v-touch tag="div" class="swipe-back" v-on:swipedown="hideFull"></v-touch>
      <vue-slideshow v-if="fullNode.show_topimg" :images="fullNode.images" :fullSizes="fixedSizes" defaultSize="scale_crop_1024_461" :speed="0"></vue-slideshow>
       <h2 class="article-title">{{fullNode.title}}</h2>
        <div class="info">
          <time class="date" :title="fullNode.date">{{fullNode.date|toYear}}</time>
          <h5 class="client-name" v-if="fullNode.client_name.length > 0">{{fullNode.client_name}}</h5>
          <h5 class="category">{{fullNode.category}}</h5>
        </div>
       <div class="body" v-html="fullNode.body"></div>
       <paragraphs v-if="fullNode.hasSections" :sections="fullNode.sections" :sizes="allSizes" :nid="fullNode.nid"></paragraphs>
    </article>
    <div class="projects main-content">
      <h2 class="content-title">{{title}}</h2>
      <ul v-if="showFilters" class="slide-filter horizontal"><li v-for="(name,key) in filters" v-on:click="filterSlides(key)" v-bind:class="{key: true, 'active': key === filter}">{{name}}</li></ul>
      <ul class="projects-list listing" :class="{'images-loaded':imgsLoaded}">
        <li v-for="(slide,si) in slides" :key="slide.nid" :data-index="si" :data-path="slide.path" :data-nid="slide.nid" :class="slide.classes">
          <figure class="preview" v-on:click.stop="showFullNode(slide)" :data-num="slide.images.length">
            <template v-for="(img,index) in slide.images">
              <template v-if="index < 1">
                <img :src="img.sizes[fixedSize]" :width="img.attributes.width" :height="img.attributes.height" />
              </template>
            </template>
            <figcaption>
              <div class="inner">
                <h4 :title="slide.category">{{slide.title}}</h4>
              </div>
            </figcaption>
          </figure>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import imagesLoaded from 'vue-images-loaded'
import VueSlideshow from './VueSlideshow.vue'
import Paragraphs from './Paragraphs.vue'
import ImageManager from './ImageManager.vue'

export default {
  name: 'projects',
  directives: {
    imagesLoaded
  },
  components: {
    VueSlideshow,
    Paragraphs
  },
  props: {
  },
  mixins: [ImageManager],
  data: function () {
    return {
      title: 'Projects',
      viewMode: 'show-listing',
      loading: false,
      slides: [],
      initSlideNum: 36,
      filter: 'all',
      filters: {all:'Projects'},
      showFilters: false,
      numSlides: 0,
      prevStopY: 0,
      loadedMore: false,
      defaultSize: 'max_1300x1300',
      hasFullImage: false,
      mediaPlaying: '',
      fullNode: {
        nid: 0,
        title: '',
        body: '',
        images: [],
        sections: [],
        date: new Date().getFullYear().toString(),
        client_name: '',
        show_topimg: false
      },
      imgsLoaded: false,
      topCarousel: null,
      fullCaption: '',
      showFullCaption: false,
      fullSizes: {},
      fixedSizes: {},
      allSizes: {},
      fixedSize: 'scalecrop_640_464'
    }
  },
  beforeRouteEnter: function (to,from,next) {
    next(function(vm) {
      vm.loading = vm.slides.length > vm.initSlideNum
      vm.initPage()
    })
  },
  created: function () {
    if (/^\/projects\/\w+/.test(this.$route.path)) {
      this.viewMode = 'show-detail'
    }
    this.showFilters = Object.keys(this.filters).length > 1
    var comp = this
    this.$parent.$on('scrolled-down', function(e) {
      if (!comp.loadedMore) {
        comp.loadMoreSlides()
      }
    })
    this.allSizes = {
      full: {},
      landscape: {},
      portrait: {}
    }
    this.$parent.$on('show-next-project', function(e) {
      comp.showNext()
    })
    this.$parent.$on('show-project', function(e) {
      comp.loadDetailNode(e.path)
    })
    window.addEventListener('hashchange', function(e) {
      comp.filterByHash()
    })
  },
  watch: {
    filters: function() {
      this.showFilters = Object.keys(this.filters).length > 1
    },
    '$route.path': function () {
      this.updateView()
    }
  },
  methods: {
    initPage: function () {
      this.fullSizes = this.$parent.fullSizes
      this.fixedSizes = this.$parent.fixedSizes
      this.allSizes = {
        full: this.fullSizes,
        landscape: this.$parent.landscapeFixedSizes,
        portrait: this.$parent.portraitFixedSizes
      }
      if (/^projects\/\w+/.test(this.$parent.alias)) {
        this.viewMode = 'show-detail'
      }
      if (this.loading !== true) {
        if (this.$parent.infoLoaded) {
          var d = this.$ls.get('sitedata');
          if (d) {
            if (d.projects_init_load) {
              this.initSlideNum = parseInt(d.projects_init_load);
            }
          }
          this.loadSlides(false)
        } else {
          var comp = this
          setInterval(function () {
            if (comp.$parent.infoLoaded == false && comp.numSlides < 1 && comp.loading == false) {
              comp.loadSlides(false)
            }
          }, 500)
        }
      }
    },
    updateView: function () {
      if (this.$parent.alias == 'projects') {
        this.hideFull()
      }
    },
    loadDetail: function () {
      var path = this.$route.path
      if (path) {
        if (path.length > 2) {
          this.loading = true
          if (path !== '/projects') {
            this.loadDetailNode(path)            
          }
        }
      }
    },
    loadDetailNode: function (path) {
      var index = _.findIndex(this.slides, function (slide) {
        return slide.path === path
      })
      var comp = this
      if (index >= 0) {
        this.showFullNode(this.slides[index], true)
        setTimeout(function () {
          comp.$parent.pageHeight = comp.$parent.calcPageHeight()
        }, 400)
      } else {
        var moreSlides = this.$ls.get('projects-full-more', null)
        if (moreSlides instanceof Array) {
          index = _.findIndex(moreSlides, function (slide) {
            return slide.path === path
          })
          if (index >= 0) {
            comp.showFullNode(moreSlides[index], true)
          }
          this.loadSlides(true)
        }
      }
      setTimeout(function () {
        comp.loading = false
      }, 200)
    },
    loadSlides: function (more) {
      var comp = this
      var refName = 'projects-full'
      if (more) {
        refName += '-more'
      }
      var loading = this.loading
      this.loading = true
      this.$parent.loadData(refName, function(data) {
        comp.addSlides(data, more)
        var ms = comp.$parent.allProjectsLoaded? loading? 1500 : 10 : 3000
        setTimeout(comp.loadMoreSlides,ms)
        comp.$parent.removeContainerClass('loading')
        comp.filterByHash()
      })
    },
    loadMoreSlides: function () {
      if (this.loadedMore === false) {
        this.loading = false
        this.loadSlides(true)
        this.loadedMore = true
      }
    },
    parseFilters: function(it) {
      if (it.hasOwnProperty('filter')) {
        if (this.filters.hasOwnProperty(it.filter) == false) {
          this.filters[it.filter] = it.category;
          this.showFilters = true
        }
        it.classes = [it.filter, 'active']
      }
    },
    filterSlides: function(filter) {
      if (!filter) {
        filter = 'all';
      }
      if (this.filter !== filter) {
        this.filter = filter
        var i = 0, it
        for (; i < this.slides.length; i++) {
          it = this.slides[i]
          if (this.filter === 'all' || this.filter === it.filter) {
            it.classes = [it.filter,'active']
          } else {
            it.classes = [it.filter,'hidden']
          }
        }
        if (this.filter !== 'all') {
          this.slides = _.sortBy(this.slides, ['catweight', 'weight'])
        } else {
          this.slides = _.sortBy(this.slides, ['weight'])
        }
      }
      window.location = '#' + filter
    },
    filterByHash: function(init) {
      var sf = window.location.hash
      var hasFilter = false
      if (typeof sf == 'string') {
        sf = sf.replace(/^#+/g,'')
        hasFilter = sf.length > 2
      } else if (init !== true) {
        sf = 'all'
        hasFilter = true
      }
      if (hasFilter) {
        this.filterSlides(sf)
      }
    },
    addSlides: function (data, more) {
      var slides = []
      for (var i = 0; i < data.items.length; i++) {
        if (typeof data.items[i] === 'object') {
          var it = data.items[i]
          it.numImages = 0
          if (it.images instanceof Array) {
            this.processImages(it)
          }
          this.parseFilters(it)
          slides.push(it)
        }
      }
      
      if (more && this.slides.length > 0) {
        for (i=0;i<slides.length;i++) {
          this.slides.push(slides[i]);
        }
        this.$parent.allProjectsLoaded = true
      } else {
        this.slides = slides
      }
      this.numSlides = this.slides.length
      var comp = this
      setTimeout(function () {
        comp.imgsLoaded = true
        comp.loadDetail()
        this.loading = false
      }, 375)
      this.$parent.pageHeight = comp.$parent.calcPageHeight()
    },
    processImages: function (slide) {
      slide.numImages = slide.images.length
      slide.hasImages = slide.numImages > 0
      for (var j = 0; j < slide.numImages; j++) {
        var cln = 'index-' + j
        var attrs = slide.images[j].attributes
        if (j === 0) {
          cln += ' active'
        }
        attrs.className = cln
        if (slide.images[j].sizes) {
          var sizes = slide.images[j].sizes
          if (typeof sizes === 'object') {
            this.filterImgSizes(sizes)
            this.$parent.preloadImg(sizes, j === 0)
            slide.images[j] = {
              sizes: sizes,
              attributes: attrs,
              type: slide.images[j].type,
              picture: slide.images[j].picture,
              active: j === 0,
              className: j === 0? 'active' : ''
            }
            
          }
        }
      }
    },
    fetchEdited: function (slide, index) {
      var comp = this
      this.$http.get(this.$parent.backend + 'jsonstyles/node-full/' + slide.nid).then(function (response) {
        if (response.data instanceof Object) {
          comp.fullNode = response.data
          var index = _.findIndex(comp.slides, function (n) {
            return n.nid === comp.fullNode.nid
          })
          if (index >= 0) {
            comp.slides[index] = response.data
          }
          comp.updateFullNode()
        }
      }, function (response) {})
    },
    updateFullNode: function () {
      var cs = this.fullNode
      cs.numImages = 0
      cs.hasImages = false
      if (!cs.show_topimg) {
        cs.show_topimg = false
      }
      var comp = this
      setTimeout(function() {
        comp.viewMode = 'show-detail'
      },250)
      if (cs.images) {
        if (cs.images instanceof Array) {
          cs.numImages = cs.images.length
          cs.hasImages = cs.numImages > 0
          this.addImageClasses(cs)
          for (var i=0;i<cs.images.length;i++) {
            if (cs.images[i].sizes) {
              this.filterImgSizes(cs.images[i].sizes)
            }
          }
        }
      }
      if (cs.sections) {
        cs.numSections = 0
        cs.hasSections = false
        if (cs.sections instanceof Array) {
          cs.numSections = cs.sections.length
          cs.hasSections = cs.numSections > 0
          if (cs.hasSections) {
            for (var i = 0; i < cs.numSections; i++) {
              this.processImages(cs.sections[i])
              this.addImageClasses(cs.sections[i])
            }
          }
        }
      }
      if (!cs.client_name) {
        cs.client_name = '';
      }
    },
    addImageClasses: function (slide,extraClass) {
      slide.imageClasses = ['num-images-' + slide.numImages]
      if (slide.numImages > 1) {
        slide.imageClasses.push('has-many')
      }
      if (!slide.image_layout) {
        slide.image_layout = 'flex-row'
      }
      if (slide.numImages > 1 && slide.image_layout !== 'max-1') {
        slide.imageClasses.push('rows')
      }
      slide.imageClasses.push(slide.image_layout)
      if (slide.image_layout.indexOf('half-') == 0) {
        slide.imageClasses.push('half')
      } else if (slide.image_layout == 'half') {
        slide.imageClasses.push('half-natural')
      }
      if (extraClass) {
        slide.imageClasses.push(extraClass)
      }
      if (slide.numImages > 0) {
        var landscapeIndex = slide.image_layout === 'half-mixed'? 0 : 1
        for (var i = 0; i < slide.numImages; i++) {
          if (slide.numImages == 2) {
            switch (slide.image_layout) {
              case 'half-portrait':
                slide.images[i].aspect = 'portrait-fixed'
                break
              case 'half-landscape':
                slide.images[i].aspect = 'landscape-fixed'
                break
              case 'half-mixed':
              case 'half-mixed-2':
                switch (i) {
                  case landscapeIndex:
                    slide.images[i].aspect = 'landscape-fixed'
                    break
                  default:
                    slide.images[i].aspect = 'portrait-fixed'
                    break
                }
                break
              default:
                slide.images[i].aspect = 'natural'
                break
            }
          } else {
            slide.images[i].aspect = 'natural'
          }
        }
      }
    },
    removeTapClasses: function() {
      var i = 0, ti = -1, sl
      for (; i < this.slides.length; i++) {
        sl = this.slides[i]
        if (sl.classes) {
          ti = sl.classes.indexOf('tapped')
          if (ti >= 0) {
            sl.classes.splice(ti, 1)
          }
        }
      }
    },
    showFullNode: function (slide, stopPop) {
      var skip = false
      if (this.$parent.touchActive === true && stopPop !== true) {
        var ti = slide.classes.indexOf('tapped')
        this.removeTapClasses()
        if (ti < 0) {
          skip = true
          slide.classes.push('tapped')
        }
      }
      if (!skip) {
        this.removeTapClasses()
        var index = this.$parent.matchEdited(slide)
        this.prevListY = this.$parent.scrollY
        if (index < 0) {
          this.addImageClasses(slide,'top-carousel')
          this.fullNode = slide
          this.updateFullNode()
        } else {
          this.fetchEdited(slide, index)
        }
        this.$parent.currId = slide.nid
        if (stopPop !== true) {
          this.$router.push(slide.path)
        }
        this.prevStopY = this.$parent.prevY
        this.$parent.scrollTo(0, 500)
        if (!slide.classes) {
          slide.classes = []
        }
        slide.classes.push('just-loaded')
        setTimeout(function() {
          var tempIndex = slide.classes.indexOf('just-loaded')
          if (tempIndex >= 0) {
            slide.classes.splice(tempIndex, 1)
          }
        }, 500)
      }
    },
    showNext: function (back) {
      var comp = this
      var index = _.findIndex(this.slides, function (n) {
        return n.nid === comp.fullNode.nid
      })
      if (index >= 0 && this.loading == false) {
        var nextIndex = back === true? index - 1 : index + 1
        var numSlides = this.slides.length
        if (nextIndex < 0) {
          nextIndex = numSlides - 1
        } else if (nextIndex >= numSlides) {
          nextIndex = 0
        }
        this.showFullNode(this.slides[nextIndex])
      }
    },
    showPrev: function () {
      this.showNext(true)
    },
    hideFull: function (stopPop) {
      if (this.viewMode !== 'show-listing') {
        this.viewMode = 'show-listing'
        if (stopPop !== true) {
          var stateObj = { context: "parent" }
          history.pushState(stateObj, "Projects", "/projects")
        }
        var comp = this
        this.loading = true
        setTimeout(function () {
          if (comp.scrolling === false) {
            comp.scrolling = true
            setTimeout(function () {
              comp.scrolling = false
            }, 2000)
          }
          comp.loading = false
        }, 100)
        setTimeout(function () {
          comp.$parent.pageHeight = comp.$parent.calcPageHeight()
          comp.$parent.scrollTo(comp.prevStopY,333)
        }, 250)
      }
    },
    toggleCaption: function () {
      this.showFullCaption = !this.showFullCaption
    }
  }
}
</script>


// WEBPACK FOOTER //
// Projects.vue?1eea8978